import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyStaysPdpHead = loadable(() => import(/* webpackChunkName: "content/stays/pdp-head" */ './StaysPdpHead'), 'StaysPdpHead');
